if (!customElements.get('photo-carousel')) {
  customElements.define(
    'photo-carousel',
    class PhotoCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.photo-carousel__slide'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.seconds = parseInt(this.dataset.autoplay, 10) || 0;

        this.onEnter = () => this.stop();
        this.onLeave = () => this.start();
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);

        this.observeProducts();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        if (this.observer) this.observer.disconnect();
      }

      go(index) {
        const total = this.slides.length;
        this.index = ((index % total) + total) % total;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      }

      start() {
        this.stop();
        if (this.seconds > 0 && this.slides.length > 1) {
          this.timer = setInterval(() => this.go(this.index + 1), this.seconds * 1000);
        }
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      observeProducts() {
        const cards = Array.from(this.querySelectorAll('.photo-carousel__product'));
        if (!cards.length) return;

        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
          cards.forEach((card) => card.classList.add('is-in-view'));
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              entry.target.style.transitionDelay = `${cards.indexOf(entry.target) * 100}ms`;
              entry.target.classList.toggle('is-in-view', entry.isIntersecting);
            });
          },
          {threshold: 0.15, rootMargin: '0px 0px -8% 0px'}
        );
        cards.forEach((card) => this.observer.observe(card));
      }
    }
  );
}
